import React from "react";
import * as axios from "axios";
import "./styles.css";

const baseUrl = 'https://api.appetito.ro/';

export default class Statistics extends React.Component {
  state = {
    statistics: [],
  };

  componentDidMount() {
    this.getStatistics();
  }

  getStatistics = async () => {
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/statistics`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    let statistics = response.data;
    let total = 0;
    for (let statistic of statistics) {
      total += statistic.ord
    }
    statistics.push({name: "Total", ord: total})
    this.setState({statistics})
  }

  render() {
    const statistics = this.state.statistics || [];

    return (
      <div className="deliverers-page deliverers-page-scroll">
        <div className="deliverers-section">
          <div className="deliverers-section-header">
            <h3 className="deliverers-section-title">Statistici</h3>
          </div>
          <div className="deliverers-table-scroll">
          <table className="deliverers-table">
            <thead>
            <tr>
              <th>Nr</th>
              <th>Nume</th>
              <th>Comenzi</th>
            </tr>
            </thead>
            <tbody>
            {statistics.map((st, i) => {
              const isTotal = st.name === 'Total';
              return (
                <tr key={i} className={isTotal ? 'deliverers-table-total-row' : ''}>
                  <td className="deliverers-table-center">{isTotal ? '' : i + 1}</td>
                  <td>{st.name}</td>
                  <td className="deliverers-table-center">{st.ord}</td>
                </tr>
              );
            })}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    )
  }
}
